import * as React from "react";
import * as staffCalculatorService from "../../services/staff-calculator-service";
import {EmployeeSalaryInfoData} from "../../models/employee-salary-info-data";
import SalaryCalculatorFormCalculatorDataPresentation from "./salary-calculator-form-calculator-data-presentation";
import styled from "styled-components";

interface SalaryCalculatorFormProps {}

interface SalaryCalculatorFormState {
    responseData: EmployeeSalaryInfoData
    loading: false
    error: any
}

class SalaryCalculatorForm extends React.Component<SalaryCalculatorFormProps, SalaryCalculatorFormState> {

    constructor(props: SalaryCalculatorFormProps) {
        super(props);
        this.state = {
            responseData: null,
            loading: false,
            error: null
        };
    }

    handleSubmit = (event) => {
        // BASIC STUFF
        event.preventDefault();

        // LOADER
        this.setState({
            responseData: null,
            loading: true,
            error: null
        } as SalaryCalculatorFormState);

        // DANE Z FORMULARZA DO KALKULACJI
        const formData = new FormData(event.target);
        const jsonObject: SalaryCalculatorFormData = {} as any;
        formData.forEach((value, key) => {
            jsonObject[key] = value;
        });

        // WYLICZANIE PRZEZ API
        staffCalculatorService
            .handleGenerateStaffCalculation(jsonObject)
            .then((responseData) => {
                if (!responseData) throw new Error("Brak danych z API");
                this.setState({
                    responseData: responseData,
                    loading: false,
                    error: null
                } as SalaryCalculatorFormState);
            })
            .catch((error) => {
                this.setState({
                    responseData: null,
                    loading: false,
                    error: 'Coś poszło nie tak!'
                } as SalaryCalculatorFormState)
            })
    };

    render() {
        const {responseData, loading, error} = this.state;
        return (
            <div>
                <FormContainer>
                    <FormWrapper onSubmit={this.handleSubmit}>
                        <InlineWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="salaryValue">WYNAGRODZENIE BRUTTO</Label>
                                <Input type="number" id="salaryValue" name="salaryValue" required placeholder={'5000'} min={0}/>
                            </HalfInputWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="employmentType">FORMA ZATRUDNIENIA</Label>
                                <Select id="employmentType" name="employmentType" required>
                                    <option value="UoP">UMOWA O PRACĘ</option>
                                    <option value="UZ">UMOWA ZLECENIE (20% KUP)</option>
                                    <option value="UZPA">UMOWA ZLECENIE (50% KUP)</option>
                                    <option value="PA">PRAKTYKI ABSOLWENCKIEK</option>
                                    <option value="UoD">UMOWA O DZIEŁO (20% KUP)</option>
                                    <option value="UoDPA">UMOWA O DZIEŁO (50% KUP)</option>
                                    <option value="UL">UMOWA LICENCYJNA (0% KUP)</option>
                                    <option value="ULPA">UMOWA LICENCYJNA (50% KUP)</option>
                                    <option value="AP">AKT POWOŁANIA</option>
                                    <option value="SN">ŚWIADCZENIA NIEPIENIEŻNE</option>
                                </Select>
                            </HalfInputWrapper>
                        </InlineWrapper>

                        <InlineWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="employmentInPlaceOfResidence">PRACA W MIEJSCU ZAMIESZKANIA</Label>
                                <Select id="employmentInPlaceOfResidence" name="employmentInPlaceOfResidence" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityPPKBaseTitle">Pracownicze plany kapitałowe</Label>
                                <Select id="socialSecurityPPKBaseTitle" name="socialSecurityPPKBaseTitle" required>
                                    <option value="false">NIE</option>
                                    <option value="true">TAK</option>
                                </Select>
                            </HalfInputWrapper>
                        </InlineWrapper>

                        <InlineWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="taxFreeAllowance">ZASTOSUJ KWOTĘ WOLNĄ OD PODATKU</Label>
                                <Select id="taxFreeAllowance" name="taxFreeAllowance" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="taxFreeAllowanceForYoungPeople">ZASTOSUJ ULGĘ - &quot;BEZ PIT DLA MŁODYCH&quot;</Label>
                                <Select id="taxFreeAllowanceForYoungPeople" name="taxFreeAllowanceForYoungPeople" required>
                                    <option value="false">NIE</option>
                                    <option value="true">TAK</option>
                                </Select>
                            </HalfInputWrapper>
                        </InlineWrapper>

                        <InlineWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityRetirementTitle">Ubezpieczenie Emerytalne</Label>
                                <Select id="socialSecurityRetirementTitle" name="socialSecurityRetirementTitle" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityDisabilityTitle">Ubezpieczenie Rentowe</Label>
                                <Select id="socialSecurityDisabilityTitle" name="socialSecurityDisabilityTitle" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                        </InlineWrapper>

                        <InlineWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityIllnessTitle">Ubezpieczenie Chorobowe</Label>
                                <Select id="socialSecurityIllnessTitle" name="socialSecurityIllnessTitle" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityAccidentTitle">Ubezpieczenie Wypadkowe</Label>
                                <Select id="socialSecurityAccidentTitle" name="socialSecurityAccidentTitle" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                        </InlineWrapper>

                        <InlineWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityHealthTitle">Ubezpieczenie Zdrowotne</Label>
                                <Select id="socialSecurityHealthTitle" name="socialSecurityHealthTitle" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityArt83Exemption">Ubezpieczenie Zdrowotne - ART 83</Label>
                                <Select id="socialSecurityArt83Exemption" name="socialSecurityArt83Exemption" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                        </InlineWrapper>

                        <InlineWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityLabourFundTitle">Fundusz Pracy</Label>
                                <Select id="socialSecurityLabourFundTitle" name="socialSecurityLabourFundTitle" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                            <HalfInputWrapper>
                                <Label htmlFor="socialSecurityEmployeeBenefitsTitle">Fundusz Gwarantowanych Świadczeń Pracowniczych</Label>
                                <Select id="socialSecurityEmployeeBenefitsTitle" name="socialSecurityEmployeeBenefitsTitle" required>
                                    <option value="true">TAK</option>
                                    <option value="false">NIE</option>
                                </Select>
                            </HalfInputWrapper>
                        </InlineWrapper>

                        <br/>
                        <br/>
                        <SubmitButton type="submit">DOKONAJ KALKULACJI WYNAGRODZENIA</SubmitButton>
                    </FormWrapper>

                </FormContainer>
                {responseData &&
                    <FormContainer style={{marginTop: 20}}>
                        <SalaryCalculatorFormCalculatorDataPresentation employeeSalaryInfoData={responseData}/>
                    </FormContainer>
                }
            </div>
        );
    }

}

/** STYLES */

const FormContainer = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1100px;
  margin: auto;  
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  flex-direction: column;
`;

const FormWrapper = styled.form`
    flex: 1;
    @media (max-width: 800px) {
        display: flex;
        flex-direction: column;
    }
`;

const Label = styled.label`
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  margin-top: 10px;
  text-transform: uppercase;  
`;

const Input = styled.input`
  width: 100%;
  text-indent: 10px;  
  border: 1px solid #ccc !important;
  border-radius: 4px;
  margin-bottom: 0 !important;  
`;

const Select = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  display: flex;
`;

const InlineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const HalfInputWrapper = styled.div`
  flex: 0 0 48%;
  @media (max-width: 800px) {
    flex: 1;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
`;

/** FORM STRUCTURE */

export interface SalaryCalculatorFormData {
    salaryValue: number
    employmentType: string
    employmentInPlaceOfResidence: boolean
    socialSecurityPPKBaseTitle: boolean
    taxFreeAllowance: boolean
    taxFreeAllowanceForYoungPeople: boolean
    socialSecurityRetirementTitle: boolean
    socialSecurityDisabilityTitle: boolean
    socialSecurityIllnessTitle: boolean
    socialSecurityAccidentTitle: boolean
    socialSecurityHealthTitle: boolean
    socialSecurityArt83Exemption: boolean
    socialSecurityLabourFundTitle: boolean
    socialSecurityEmployeeBenefitsTitle: boolean
}

export default SalaryCalculatorForm


// WEBPACK FOOTER //
// ./src/layouts/salary-calculator-form-block/salary-calculator-form.tsx